export const environment = {
  production: false,
  apiUrl: 'https://techsurance-test-api.clevernav.ai'
};
